import { Component } from '@verndale/core';
import { LoadSequence } from '../helpers/animations';
import { mediaQuery } from '../helpers/media-queries';

class MediaMasthead extends Component {
  constructor(el: HTMLElement) {
    super(el);
    this.loadAnimations();
  }

  setupDefaults() {
    this.dom = {
      videoContainer: this.el.querySelector<HTMLElement>('.video'),
      description: this.el.querySelector<HTMLElement>('.module-header__description'),
      eyebrow: this.el.querySelector<HTMLElement>('.eyebrow'),
      title: this.el.querySelector<HTMLElement>('.module-header__title'),
      buttons: this.el.querySelector<HTMLElement>('.module-header__buttons')
    };
  }

  loadAnimations() {
    if (mediaQuery('tablet').matches) {
      LoadSequence(this.el, [
        { element: this.dom.videoContainer as HTMLElement, addScale: true, offset: 0 },
        { element: this.dom.eyebrow as HTMLElement, addScale: false, offset: 0.3 },
        { element: this.dom.title as HTMLElement, addScale: false, offset: 0.3 },
        { element: this.dom.description as HTMLElement, addScale: false, offset: 0.4 },
        { element: this.dom.buttons as HTMLElement, addScale: false, offset: 0.5 }
      ]);
    } else {
      LoadSequence(this.el, [
        { element: this.dom.videoContainer as HTMLElement, addScale: true, offset: 0 },
        { element: this.dom.eyebrow as HTMLElement, addScale: false, offset: 0.3 },
        { element: this.dom.title as HTMLElement, addScale: false, offset: 0.4 },
        { element: this.dom.description as HTMLElement, addScale: false, offset: 0.5 },
        { element: this.dom.buttons as HTMLElement, addScale: false, offset: 0.6 }
      ]);
    }
  }
}

export default MediaMasthead;
